/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Insufficientcredits_Close1Inputs */

const zh_chat_insufficientcredits_close1 = /** @type {(inputs: Chat_Insufficientcredits_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稍后再说`)
};

const en_chat_insufficientcredits_close1 = /** @type {(inputs: Chat_Insufficientcredits_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maybe Later`)
};

const es_chat_insufficientcredits_close1 = /** @type {(inputs: Chat_Insufficientcredits_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quizás después`)
};

/**
* | output |
* | --- |
* | "Maybe Later" |
*
* @param {Chat_Insufficientcredits_Close1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_insufficientcredits_close1 = /** @type {((inputs?: Chat_Insufficientcredits_Close1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Insufficientcredits_Close1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_insufficientcredits_close1(inputs)
	if (locale === "en") return en_chat_insufficientcredits_close1(inputs)
	return es_chat_insufficientcredits_close1(inputs)
});
export { chat_insufficientcredits_close1 as "chat_insufficientCredits_close" }